<template>
  <div class="train-notice-page">
    <div class="inner-nav">
      <div class="breadcrumb">
        <span class="crumb-link" @click="goHome">首页</span>
        <span class="crumb-sep">/</span>
        <span class="crumb-current">{{ pageTitle }}</span>
      </div>
    </div>

    <div class="tabs-wrap" v-loading="loadingCategories">
      <div
        v-for="item in categories"
        :key="item.ncId"
        class="tab-item"
        :class="{ active: activeNcId === item.ncId }"
        @click="handleCategoryClick(item)"
      >
        {{ item.name }}
      </div>
    </div>

    <div class="notice-list" v-loading="loadingList">
      <template v-if="newsList.length > 0">
        <div
          v-for="item in newsList"
          :key="item.newsId"
          class="notice-row"
          @click="openNews(item.newsId)"
        >
          <div class="cover-wrap">
            <el-image class="cover" :src="item.thumbUrl" fit="cover">
              <div slot="error" class="cover-empty">暂无图片</div>
            </el-image>
          </div>
          <div class="info-wrap">
            <div class="title">{{ item.title }}</div>
            <div class="publish-time">发布时间：{{ item.createTime || "-" }}</div>
          </div>
        </div>
      </template>

      <div v-else class="empty-wrap">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  name: "TrainNotice",
  data() {
    return {
      modelType: 1,
      categories: [],
      activeNcId: null,
      newsList: [],
      loadingCategories: false,
      loadingList: false
    };
  },
  computed: {
    pageTitle() {
      return this.modelType === 0 ? "信息资讯" : "培训通知";
    }
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.initByRoute();
      }
    }
  },
  created() {
    this.initByRoute();
  },
  methods: {
    goHome() {
      this.$router.push("/home");
    },
    parseModelType() {
      const val = Number(this.$route.query.modelType);
      return val === 0 || val === 1 ? val : 1;
    },
    async initByRoute() {
      this.modelType = this.parseModelType();
      this.activeNcId = null;
      this.newsList = [];
      await this.loadCategories();
      if (this.activeNcId) {
        await this.loadNewsList(this.activeNcId);
      }
    },
    async loadCategories() {
      this.loadingCategories = true;
      try {
        const res = await httpRequest("/app/news/category/categorys", "get", {
          modelType: this.modelType
        });
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.categories = res.data;
          this.activeNcId = this.categories.length ? this.categories[0].ncId : null;
        } else {
          this.categories = [];
          this.activeNcId = null;
        }
      } finally {
        this.loadingCategories = false;
      }
    },
    async loadNewsList(ncId) {
      this.loadingList = true;
      try {
        const res = await httpRequest("/app/news/newss", "get", {
          ncId,
          currentPage: 1,
          pageSize: 10000
        });
        if (res && res.code === 200 && res.data && Array.isArray(res.data.list)) {
          this.newsList = res.data.list;
        } else {
          this.newsList = [];
        }
      } finally {
        this.loadingList = false;
      }
    },
    async handleCategoryClick(item) {
      if (!item || item.ncId === this.activeNcId) {
        return;
      }
      this.activeNcId = item.ncId;
      await this.loadNewsList(this.activeNcId);
    },
    openNews(newsId) {
      this.$router.push({
        path: "/news",
        query: {
          newsId,
          modelType: String(this.modelType),
          parentTitle: this.pageTitle
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.train-notice-page {
  width: 1200px;
  margin: 18px auto 0;
  min-height: calc(100vh - 77px - 100px - 18px);
  text-align: left;
  padding-bottom: 20px;

  .inner-nav {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 8px;
    color: #6f7682;

    .breadcrumb {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 1;
    }

    .crumb-link {
      color: #2f7fe0;
      cursor: pointer;
    }

    .crumb-sep {
      margin: 0 8px;
      color: #aab1bc;
    }

    .crumb-current {
      color: #3c4250;
      font-weight: 500;
    }

  }

  .tabs-wrap {
    min-height: 52px;
    border-bottom: 1px solid #d9dde6;
    display: flex;
    align-items: flex-end;
    background: transparent;

    .tab-item {
      height: 52px;
      line-height: 52px;
      margin-right: 48px;
      color: #232323;
      font-size: 18px;
      cursor: pointer;
      position: relative;
      user-select: none;
      transition: color 0.2s;

      &:hover {
        color: #2f7fe0;
      }

      &.active {
        color: #2f7fe0;
        font-weight: 600;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          height: 3px;
          background: #2f7fe0;
        }
      }
    }
  }

  .notice-list {
    .notice-row {
      display: flex;
      align-items: center;
      padding: 24px 0;
      border-bottom: 1px solid #eceff4;
      cursor: pointer;

      .cover-wrap {
        width: 290px;
        height: 160px;
        flex-shrink: 0;

        .cover {
          width: 100%;
          height: 100%;
        }

        .cover-empty {
          width: 100%;
          height: 100%;
          background: #f2f4f8;
          color: #a0a6b1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
        }
      }

      .info-wrap {
        margin-left: 18px;
        min-width: 0;
        flex: 1;

        .title {
          color: #2480e3;
          font-size: 20px;
          line-height: 1.6;
          font-weight: 600;
        }

        .publish-time {
          margin-top: 46px;
          color: #9fa5af;
          font-size: 16px;
        }
      }

      &:hover .title {
        color: #1668c7;
      }
    }

    .empty-wrap {
      padding: 48px 0;
    }
  }
}

@media (max-width: 1240px) {
  .train-notice-page {
    width: calc(100vw - 40px);
    min-width: 1160px;
  }
}
</style>
